import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;
const ENV = process.env.NODE_ENV ?? "development";

let initialised = false;

/**
 * Initialise Sentry for the React app. Safe to call multiple times. When
 * REACT_APP_SENTRY_DSN is unset (the default in local dev), this is a no-op
 * and the rest of the app continues unchanged.
 */
export function initSentry(): void {
  if (initialised || !DSN) return;
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
  initialised = true;
}

export { Sentry };
